import { Component } from '@angular/core';

import { ConfirmationService } from 'primeng/api';

import { MessageService } from '../../../services/message.service';

import { Dialog } from '../../../models/dialog.model';
import { DialogType, OptionType } from '../../../enumerators/messages.enum';

@Component({
  selector: 'app-dialog',
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.scss']
})
export class DialogComponent {
  dialog: Dialog = new Dialog();

  public animation: string = "";
  public icon: string = "";
  public isOpen: boolean = false;
  public optionType = OptionType;
  public iconClass: string = "";

  constructor(private dialogService: MessageService, private confirmationService: ConfirmationService) {
  }

  ngOnInit() {
    this.dialogService.startDialog().subscribe((dialogo: Dialog) => {
      this.dialog = dialogo;
      this.openDialog();
    });
  }

  openDialog() {

    this.setDialogData(this.dialog);

    this.confirmationService.confirm({
      message: this.dialog.message,
      header: this.dialog.title,
      icon: this.icon,
      accept: () => {
        this.closeDialog(true);
      },
      reject: () => {
        this.closeDialog(false);
      },
      key: 'dialog'
    });



  }

  closeDialog(response: any) {
    this.animation = "fadeOutDown";

    setTimeout(() => {
      this.dialogService.sendDialogResponse(response);
      this.icon = "";
      this.isOpen = false;
      this.dialog = new Dialog();
    }, 310);

  }

  setDialogData(dialog: Dialog) {
    switch (dialog.type) {
      case DialogType.Normal:
        this.icon = "material-icons-outlined mi-info";
        break;

      case DialogType.Advise:
        this.icon = "material-icons-outlined mi-warning";
        this.iconClass = "aviso";
        break;

      default:
        break;
    }
  }
}
